import React from "react"
import {
  PageProps,
  // useStaticQuery,
  // graphql
} from "gatsby"
import classnames from "classnames"
// import BackgroundImage from "gatsby-background-image"

import Layout from "@components/Layout"
import SEO from "@components/SEO"
import { useTranslation } from "@hooks"

import TattooStudio from "@components/App/TattooStudio"
import Trust from "@components/Add/Trust"
import Residents from "@components/Add/Residents"
import Guests from "@components/Add/Guests"

import Section from "react-bulma-components/lib/components/section"
import Container from "react-bulma-components/lib/components/container"
import Heading from "react-bulma-components/lib/components/heading"
import Columns from "react-bulma-components/lib/components/columns"
import Card from "react-bulma-components/lib/components/card"
import Content from "react-bulma-components/lib/components/content"
import Hero from "react-bulma-components/lib/components/hero"

import styles from "./styles.module.scss"

const Add = (props: PageProps) => {
  const [t] = useTranslation()

  // const data = useStaticQuery(graphql`
  //   query {
  //     img: file(relativePath: { eq: "sell-on-iynk-header-background.jpg" }) {
  //       childImageSharp {
  //         fluid(quality: 100) {
  //           aspectRatio
  //           # ...GatsbyImageSharpFluid // With blur-up
  //           ...GatsbyImageSharpFluid_noBase64
  //         }
  //       }
  //     }
  //   }
  // `)

  const why = [
    {
      title: "Build Trust",
      image: <Trust />,
      content:
        "IYNK is building a trusted platform for people to book tattoos. Don't miss out.",
    },
    {
      title: "Resident Artists",
      image: <Residents />,
      content:
        "Showcase the artist you have permanently working in your studio.",
    },
    {
      title: "Guest Artists",
      image: <Guests />,
      content:
        "Send and receive requests for artists to work temporarily at your studio.",
    },
  ]

  return (
    <Layout>
      <SEO
        title={t("pages.Add.seo.title")}
        description={t("pages.Add.seo.description")}
      />

      <Hero size="medium">
        {/* <BackgroundImage Tag="section" fluid={data.img.childImageSharp.fluid}> */}
        <Hero.Body className={"has-background-black"}>
          <Container className={classnames("has-text-centered")}>
            <Heading
              className={classnames(styles.Add__heading, "has-text-white-bis")}
            >
              {t("pages.Add.heading")}
            </Heading>
            <p
              className={classnames(
                styles.Add__description,
                "has-text-white-bis"
              )}
            >
              Promote your studio and your artists and build more trust.
            </p>
          </Container>
        </Hero.Body>
        {/* </BackgroundImage> */}
      </Hero>
      <Container>
        <Section>
          <Columns breakpoint="mobile" className={"is-vcentered"}>
            {why.map((w, i) => (
              <Columns.Column
                key={i}
                mobile={{
                  size: 12,
                }}
                tablet={{
                  size: 4,
                }}
                desktop={{
                  size: 4,
                }}
                widescreen={{
                  size: 4,
                }}
                fullhd={{
                  size: 4,
                }}
                className={"has-text-centered"}
              >
                <Card className={"is-card-equal-height"}>
                  <div className={styles.Add__whyImage}>
                    {w.image && w.image}
                    <div className={styles.Add__whyGradient} />
                  </div>
                  <Card.Content className={styles.Add__whycontent}>
                    <Heading renderAs={"h4"} size={5}>
                      {w.title}
                    </Heading>
                    <p>{w.content}</p>
                  </Card.Content>
                </Card>
              </Columns.Column>
            ))}
          </Columns>
        </Section>
        <Section>
          <Columns breakpoint="mobile" className={"is-vcentered"}>
            <Columns.Column
              mobile={{
                size: 12,
              }}
              tablet={{
                size: 6,
              }}
              desktop={{
                size: 6,
              }}
              widescreen={{
                size: 6,
              }}
              fullhd={{
                size: 6,
              }}
            >
              <div className={"reverse"}></div>
              <Card className={"is-card-equal-height"} shadowless>
                <Card.Content>
                  <Content>
                    <Heading renderAs={"h2"} size={4}>
                      How to list
                    </Heading>
                    It’s easy to get started – just create a studio account. Add
                    your address and opening times. Then you can add your
                    resident and guest artists.
                  </Content>
                </Card.Content>
              </Card>
            </Columns.Column>
            <Columns.Column
              mobile={{
                size: 12,
              }}
              tablet={{
                size: 6,
              }}
              desktop={{
                size: 6,
              }}
              widescreen={{
                size: 6,
              }}
              fullhd={{
                size: 6,
              }}
            >
              <Card className={"is-card-equal-height"}>
                <TattooStudio />
              </Card>
            </Columns.Column>
          </Columns>
        </Section>
      </Container>
    </Layout>
  )
}

export default Add
